import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppStore } from '../../store/AppStore';
import { ClearNotificationsAction } from '../../store/action/NotificationActions';
import { LogoutAction } from '../../store/action/UserActions';
import { SurveyClearErrorsAction } from '../../store/action/SurveyActions';
import { TrainingClearErrorsAction } from '../../store/action/TrainingActions';
import { BrainstormClearErrorsAction } from '../../store/action/BrainstormActions';
import { LoginPage } from '../login/login';
import { NotificationService } from '../../services/NotificationService';
import { NotificationModel } from '../../model/NotificationModel';
import { SurveyPage } from '../survey/survey';
import { TrainingPage } from '../training/training';
import { IntermarketingPage } from '../intermarketing/intermarketing';
import { CronosClearErrorsAction } from '../../store/action/CronosActions';

@IonicPage({
  name: 'notification-page',
  segment: 'notification/:data'
})
@Component({
  selector: 'page-notification',
  templateUrl: 'notification.html',
})
export class NotificationPage {

  public clientId: number = null;
  public userId: number = null;
  private loggingOff: boolean;
  private navigating: boolean;

  private userStateSubscription: Subscription;
  private notificationStateSubscription: Subscription;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    private toastCtrl: ToastController,
    public notificationService: NotificationService,
    private store: Store<AppStore>
  ) {
    
  }

  ionViewDidEnter() {
    this.loggingOff = false;
    this.navigating = false;

    this.userStateSubscription = this.store.select('userState').subscribe(userState => {
      if (userState.expired == true && !this.loggingOff) {
        this.loggingOff = true;
        this.logoff();
      }
      if (userState.user != null) {
        this.clientId = userState.user.clienteId;
        this.userId = userState.user.id;
      }
    });

    this.notificationStateSubscription = this.store.select('notificationState').subscribe(notificationState => {
      if (notificationState.data != null && !this.navigating) {
        if (this.navParams.get('data') != null) {
          const arrData = this.navParams.get('data').split(',');
          let itemCopy = notificationState.data.find(x => x.id == arrData[0]);
          itemCopy.status = 2;
          this.notificationService.updateNotification(itemCopy)
            .subscribe(resp => {
              this.navigating = true;
              this.navigateNotification(itemCopy);
            },
            err => {
              this.presentToast('Erro ao atualizar status da notificação');
            });
        }    
      }
    });    
  }

  ionViewWillLeave() {
    if (this.userStateSubscription != null) this.userStateSubscription.unsubscribe();
    if (this.notificationStateSubscription != null) this.notificationStateSubscription.unsubscribe();
  }

  navigateNotification(item: NotificationModel) {
    if (item.servicoNotificacao == 1) {
      const linkArraySurvey: Array<string> = item.linkNotificacao.split('?');
      const linkDataSurvey: Array<string> = linkArraySurvey[linkArraySurvey.length - 1].split('-');
      this.navCtrl.setRoot(SurveyPage, { surveyId: linkDataSurvey[0], surveyType: linkDataSurvey[1] });
    } else if (item.servicoNotificacao == 2) {
      const linkArray: Array<string> = item.linkNotificacao.split('/');
      this.navCtrl.setRoot(TrainingPage, { trainingId: linkArray[linkArray.length - 1] });  
    } else if (item.servicoNotificacao == 3) {
      this.navCtrl.setRoot(IntermarketingPage, { id: item.id, messageId: item.mensagemId });
    }
  }

  logoff() {
    this.presentToast('Acesso expirado. Efetue login novamente. (8)');
    localStorage.removeItem('expirationDate');
    this.store.dispatch(new LogoutAction());
    this.store.dispatch(new SurveyClearErrorsAction());
    this.store.dispatch(new TrainingClearErrorsAction());
    this.store.dispatch(new BrainstormClearErrorsAction());
    this.store.dispatch(new ClearNotificationsAction());
    this.store.dispatch(new CronosClearErrorsAction());
    this.navCtrl.setRoot(LoginPage);
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });  
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/notification/notification.ts